import React, { useState, useCallback } from "react";
import { useUser } from "../../../util/user";
import { Redirect } from "react-router-dom";

// Redirect to default site creation page based on user's role
function SiteCreationRedirect(props) {
	const user = useUser();
	const siteView = user.roles.includes("administration:SiteCreation:_view");
	const siteLicense = user.roles.includes("administration:SiteCreation:_license");
	const siteAdmin = user.roles.includes("administration:SiteCreation:_admin");
	const siteCons = user.roles.includes("administration:SiteCreation:_editCons");
	const consApproval = user.roles.includes("administration:SiteCreation:_approvalCons");

	const redirectPath = (function() {
		if(!siteView) {
			return "/solar/administration"
		}
		if(siteAdmin) {
			return "/solar/administration/site-creation/manage-site/execution-table";
		}
		if(siteLicense) {
			return "/solar/administration/site-creation/manage-site/operating-table";
		}
		if(siteCons || consApproval) {
			return "/solar/administration/site-creation/manage-site/construction-table";
		}
		return "/solar/administration/site-creation/manage-site/invoicing-info-table";
	})();
  
	return <Redirect to={redirectPath} />
}

export default SiteCreationRedirect;
